import { memo, useMemo } from 'react'
import { AnimatePresence, motion } from 'framer-motion'

export const AnimatedLabel = memo(
  ({
    animId,
    label,
    transitionMs = 150,
    delay = 0,
    scale,
    className,
  }: {
    animId?: string
    label: string | React.ReactElement
    transitionMs?: number
    delay?: number
    scale?: boolean
    className?: string
  }) => {
    const animation = useMemo(() => {
      const startScale = !scale ? 1 : 0.9
      return {
        initial: { opacity: 0.5, filter: 'blur(2px)', scale: startScale },
        animate: { opacity: 1, filter: 'blur(0px)', scale: 1 },
        exit: { opacity: 0.5, filter: 'blur(2px)', scale: startScale },
      }
    }, [scale])

    const transition = useMemo(() => {
      return { duration: transitionMs / 1000, delay }
    }, [transitionMs, delay])

    const key = useMemo(() => {
      if (animId) {
        return animId
      }
      const isString = typeof label === 'string'
      if (isString) {
        return label
      }
      if (label.key) {
        return label.key
      }
      return undefined
    }, [animId, label])

    return (
      <AnimatePresence mode="wait">
        <motion.span key={key} {...animation} transition={transition} className={className}>
          {label}
        </motion.span>
      </AnimatePresence>
    )
  },
)
AnimatedLabel.displayName = 'AnimatedLabel'
